import UIComponent from "sap/ui/core/UIComponent";
import {SharedServices} from "niteroi/services/SharedServices";
import RouteServices from "niteroi/services/RouteServices";
import ComponentSupport from "sap/ui/core/ComponentSupport";

/**
 * Root Shell Component
 * Minimal orchestrator that loads package components via ComponentContainer
 * Uses SharedServices for common initialization logic
 *
 * @namespace niteroi
 */
export default class RootComponent extends UIComponent {
    public static metadata = {
        interfaces: ["sap.ui.core.IAsyncContentCreation"],
        manifest: "json",
    };
    private _routeServices: RouteServices | undefined;

    /**
     * Initialize shell component
     */
    public init(): void {
        super.init();

        this.setModel(SharedServices.createDeviceModel(), "device");

        SharedServices.registerIconLibraries();
        SharedServices.registerIllustrationSets();

        this._routeServices = new RouteServices(this);
        ComponentSupport.run();
    }

    public getRouteServices(): RouteServices | undefined {
        return this._routeServices;
    }
}
